// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"f7a431a54eadb1dd7413","293":"1077d73604410903d70a","518":"03424dcf267137462158","779":"ae9075cbde700314d321"}[chunkId] + ".js";
};